import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { formatShortDateFromNow } from '../../../../../utils/date-utils/dateUtils';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { NotificationReadStatus } from '../status/NotificationReadStatus';
import { NotificationWatcherDecisionType } from '../../../notification.types';
import {
  sendNotificationClickedEvent,
  getNotificationTrackingParameters,
} from '../../../notificationUtils';
import { StateType } from '../../../../../state/reducers';
import { NotificationWatcherTitle } from '../../title/NotificationWatcherTitle';
import { NotificationWatcherQuery } from '../../query/NotificationWatcherQuery';
import { NotificationLink } from '../../link/NotificationLink';
import { NotificationLinkContent } from '../../link/NotificationLinkContent';
import { NotificationLinkDate } from '../../link/NotificationLinkDate';

type Props = {
  notification: NotificationWatcherDecisionType;
  notificationClicked: Function;
};

export const NotificationWatcherDecision: FC<Props> = ({
  notificationClicked,
  notification,
}) => {
  const { isAlreadyRead } = useSelector(({ notifications }: StateType) => ({
    isAlreadyRead: !!notifications.notifReadStatusMap[notification.id],
  }));

  const onNotificationClicked = (
    event: React.MouseEvent<HTMLAnchorElement>,
  ) => {
    sendNotificationClickedEvent();
    notificationClicked(notification)(event);
  };

  const { watcherDecision } = notification.data;
  return (
    <NotificationLink
      href={buildUrlWithParameters(notification.link, {
        watcher_key: watcherDecision.key,
        ...getNotificationTrackingParameters(notification),
      })}
      onClick={onNotificationClicked}
      data-test-id="notification-watcher-decision"
    >
      <NotificationReadStatus notificationId={notification.id} />
      <NotificationLinkContent>
        <NotificationWatcherQuery isAlreadyRead={isAlreadyRead}>
          {watcherDecision.query}
        </NotificationWatcherQuery>
        <NotificationWatcherTitle>
          {watcherDecision.title}
        </NotificationWatcherTitle>
        <NotificationLinkDate>
          {formatShortDateFromNow(notification.date)}
        </NotificationLinkDate>
      </NotificationLinkContent>
    </NotificationLink>
  );
};
